// Outline icons for navigation v2, from the approved nav canvas (2026-10-16).
// Stroke-only, currentColor, 24px grid; size comes from the className.

import type { ReactNode } from 'react'

function Svg({ className, children, strokeWidth, strokeLinecap, strokeLinejoin }: {
  className: string
  children: ReactNode
  strokeWidth: string
  strokeLinecap?: 'round'
  strokeLinejoin?: 'round'
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      className={className}
    >
      {children}
    </svg>
  )
}

export function SearchIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" className={className}>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </Svg>
  )
}

export function ScanIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="2" strokeLinecap="round" className={className}>
      <path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3" />
      <rect x="8.5" y="7" width="7" height="10" rx="1" />
    </Svg>
  )
}

export function HomeTabIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinejoin="round" className={className}>
      <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
    </Svg>
  )
}

export function BracketTabIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" className={className}>
      <path d="M5 20V11M12 20V4M19 20v-6M3 20h18" />
    </Svg>
  )
}

export function CollectionTabIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinejoin="round" className={className}>
      <rect x="3" y="4" width="18" height="4" rx="1" />
      <path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8M10 12h4" />
    </Svg>
  )
}

export function DecksTabIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinejoin="round" className={className}>
      <path d="M12 3l9 5-9 5-9-5z" />
      <path d="M3 13l9 5 9-5" />
    </Svg>
  )
}

export function BuildIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M14 6l4 4M11 9l6-6 4 4-6 6zM12 10l-8 8 2 2 8-8" />
    </Svg>
  )
}

export function JudgeIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinejoin="round" className={className}>
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M19 19v2H6" />
    </Svg>
  )
}

export function ExploreIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.5l-2 5-5 2 2-5z" />
    </Svg>
  )
}

export function WatchtowerIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M9 21l1-9h4l1 9M8 12h8M10 12V8h4v4M12 8V4M9 4h6" />
    </Svg>
  )
}

export function GuidesIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14" />
    </Svg>
  )
}

export function BlogIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    </Svg>
  )
}

export function AccuracyIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" className={className}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" />
    </Svg>
  )
}

export function AboutIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </Svg>
  )
}

export function SupportIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z" />
      <path d="M9.5 9.5a2.5 2.5 0 0 1 4.9.6c0 1.6-2.4 2-2.4 3.4M12 16h.01" />
    </Svg>
  )
}

export function PartnersIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M9 7H7a5 5 0 0 0 0 10h2M15 7h2a5 5 0 0 1 0 10h-2M8 12h8" />
    </Svg>
  )
}

export function PrivacyIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  )
}

export function CloseIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <Svg strokeWidth="2" strokeLinecap="round" className={className}>
      <path d="M6 6l12 12M18 6L6 18" />
    </Svg>
  )
}

/** The Build tab's glyph, the same wrench as MobileNav v1's Build tab (filled). */
export function BuildTabIcon({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path fillRule="evenodd" d="M12 6.75a5.25 5.25 0 016.775-5.025.75.75 0 01.313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 011.248.313 5.25 5.25 0 01-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 112.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0112 6.75z" clipRule="evenodd" />
    </svg>
  )
}

export function ChevronDownIcon({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Svg strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M6 9l6 6 6-6" />
    </Svg>
  )
}

export function CheckIcon({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Svg strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </Svg>
  )
}
